import { render, staticRenderFns } from "./procurement_history.vue?vue&type=template&id=974925aa&scoped=true&"
import script from "./procurement_history.vue?vue&type=script&lang=js&"
export * from "./procurement_history.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "974925aa",
  null
  
)

export default component.exports